import { ReactComponent as AddPlaylistIcon } from "../../assets/images/add-playlist.svg";
import { ReactComponent as AddToQueueIcon } from "../../assets/images/add-to-queue.svg";
import { ReactComponent as Playlist } from "../../assets/images/playlist.svg";
import { ReactComponent as Like } from "../../assets/images/like.svg";
import { ReactComponent as DisLike } from "../../assets/images/dislike.svg";
import { ReactComponent as BrowsingHistory } from "../../assets/images/history.svg";
import { ReactComponent as Add } from "../../assets/images/add.svg";
import { ReactComponent as Close } from "../../assets/images/close.svg";
import { ReactComponent as Play } from "../../assets/images/play.svg";
import { ReactComponent as DownArrow } from "../../assets/images/down-arrow.svg";
import { ReactComponent as Dot } from "../../assets/images/dot.svg";

import CONSTANT from "../../constants/constant";

const Icon = ({ color, size, type }) => {
  switch (type) {
    case CONSTANT.ICON.ADD_TO_PLAYLIST: {
      return <AddPlaylistIcon stroke={color} width={size} height={size} />;
    }
    case CONSTANT.ICON.ADD_TO_QUEUE: {
      return (
        <AddToQueueIcon
          stroke={color}
          fill={color}
          width={size}
          height={size}
        />
      );
    }
    case CONSTANT.ICON.LIKE: {
      return <Like stroke={color} fill={color} width={size} height={size} />;
    }
    case CONSTANT.ICON.DISLIKE: {
      return <DisLike stroke={color} fill={color} width={size} height={size} />;
    }
    case CONSTANT.ICON.PLAYLIST: {
      return (
        <Playlist stroke={color} fill={color} width={size} height={size} />
      );
    }
    case CONSTANT.ICON.BROWSING_HISTORY: {
      return (
        <BrowsingHistory
          stroke={color}
          fill={color}
          width={size}
          height={size}
        />
      );
    }
    case CONSTANT.ICON.ADD: {
      return <Add stroke={color} fill={color} width={size} height={size} />;
    }
    case CONSTANT.ICON.CLOSE: {
      return <Close stroke={color} fill={color} width={size} height={size} />;
    }
    case CONSTANT.ICON.PLAY: {
      return <Play stroke={color} fill={color} width={size} height={size} />;
    }
    case CONSTANT.ICON.DOWN_ARROW: {
      return (
        <DownArrow stroke={color} fill={color} width={size} height={size} />
      );
    }
    case CONSTANT.ICON.DOT: {
      return <Dot stroke={color} fill={color} width={size} height={size} />;
    }
    default: {
      break;
    }
  }
};

export default Icon;
